import { render, staticRenderFns } from "./aiEditControls.pug?vue&type=template&id=32a3db5e&scoped=true&lang=pug&"
import script from "./AiEditControls.vue?vue&type=script&lang=js&"
export * from "./AiEditControls.vue?vue&type=script&lang=js&"
import style0 from "./AiEditControls.vue?vue&type=style&index=0&id=32a3db5e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3db5e",
  null
  
)

/* custom blocks */
import block0 from "./AiEditControls.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports